import { UpdateInstanceForm } from '../../forms';

export default function UpdateInstance() {
  return (
    <div className="px-4 sm:space-y-0 sm:gap-4 sm:px-6 sm:py-4">
      <UpdateInstanceForm />
    </div>
  );
}
